import { HeaderPrintListProps } from "./AddHeaderSapiensPrintList";
import { generateHeaderPdf, getHeaderStaticPdf, mergedPdfHeader } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/fm_opd_027.pdf";
// const FONT = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormKneeReplacementTH = async (props: any) => {
  try {
    const pdfPath = props.items?.headerInfo?.file_path ?? PDF;
    const existingPdfBytes = await fetch(pdfPath).then((res) => res.arrayBuffer());
    const pdfBytes = new Uint8Array(existingPdfBytes);

    const headerConfigList: HeaderPrintListProps[] = [
      // Page 1
      { headerMargins: [12, 8, 13, 0], freeLine: 1, extraCanvasHeight: 21 },
      // Page 2
      { headerMargins: [12, 12, 13, 0], freeLine: 1, extraCanvasHeight: 40 },
      // Page 3 & 4
      { headerMargins: [12, 10, 13, 0], freeLine: 1, extraCanvasHeight: 20 },
    ];

    const headerDefs = await Promise.all(
      headerConfigList.map((config) =>
        getHeaderStaticPdf(
          {
            formName: `${props.items?.headerInfo?.name}\n(${props.items?.headerInfo?.name_en})`,
            patientInfo: props.items,
            detail: props.detail,
            ...config,
          },
          "mini"
        )
      )
    );

    const headerPdfBytesList = await Promise.all(headerDefs.map((def) => generateHeaderPdf(def)));

    const mergedPdfBytes = await mergedPdfHeader(pdfBytes, headerPdfBytesList);

    const blob = new Blob([mergedPdfBytes as BlobPart], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    return {
      uint8Array: mergedPdfBytes,
      blobUrl,
      blobRaw: blob,
      base64String: Buffer.from(mergedPdfBytes).toString("base64"),
    };
  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormKneeReplacementTH;
